import ChildManage from './ChildManage'
export default ChildManage


// WEBPACK FOOTER //
// ./src/pages/child/manage/index.js